<template>
  <div class="px-3">
    <input type="hidden" name="_token" :value="csrf" />
    <div v-if="permission > 1">
      <button
        type="button"
        class="btn btn--green"
        data-toggle="modal"
        :data-target="'#addProjectModal' + this.question_survey_id"
      >
        {{ __("forms.questions.question16.newProject") }}
      </button>
    </div>
    <div style="margin-top: 20px">
      <p>{{ __("forms.question16.projects") }}</p>
      <table style="overflow: hidden" class="table-custom-header table">
        <thead>
          <tr>
            <th style="width: 40px; max-width: 40px"></th>
            <th>{{ __("forms.EvaluationChart.questions.questions_setting.question16.client") }}</th>
            <th>{{ __("forms.EvaluationChart.questions.questions_setting.question16.project") }}</th>
            <th>{{ __("forms.EvaluationChart.questions.questions_setting.question16.assigned_by") }}</th>
            <th style="width:100px !important">{{ __("forms.EvaluationChart.questions.questions_setting.question16.duration") }}</th>
            <th style="width:100px !important">{{ __("forms.EvaluationChart.questions.questions_setting.question16.commitment") }}</th>
            <th style="width:100px !important">{{ __("forms.EvaluationChart.questions.questions_setting.question16.notes") }}</th>
          </tr>
        </thead>
        <tbody v-if="!empty_values">
          <tr v-for="(row, ind) in tableProjects" :key="ind">
            <td
              class="icon-button"
              v-if="permission > 1 && row.add_from_chart > 0"
            >
              <a @click="rmProject(row)" class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove hrt-button">
                  <i class="fas fa-trash"> </i>
              </a>
            </td>
            <td v-else></td>
            <td>{{ row.client_name }}</td>
            <td>{{ row.project_name }}</td>
            <td>{{ row.assigned_by_person }}</td>

            <td style="width:100px !important">
              <span v-if="permission < 2">
                {{ row.duration }}
              </span>
              <input
                v-else
                type="number"
                class="form-control"
                v-model="row.duration"
                @change="updateProjectRow(row, 'duration', $event)"
              />
            </td>
            <td style="width:100px !important">
              <span v-if="permission < 2">
                {{ row.commitment }}
              </span>
              <input
                v-else
                type="number"
                class="form-control"
                v-model="row.commitment"
                @change="updateProjectRow(row, 'commitment', $event)"
              />
            </td>
            <td style="width:100px !important" class="icon-button">
              <a @click="openNote(row.project_name,row.note)" v-if="row.note !== '' && row.note !== null" href="#" class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history">
                  <i class="fas fa-info"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- modals -->
    <div
      class="modal fade"
      :id="'addProjectModal' + this.question_survey_id"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addProjectModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 1.5rem">
          <div class="modal-header">
            <h5 class="modal-title" id="addProjectModalLabel">
              {{ __("forms.questions.question16.addProject") }}
            </h5>
            <button
              type="button"
              ref="addProjectCloseModal"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row py-5">
              <div class="col-12 col-md-6">
                <label>{{ __("forms.EvaluationChart.questions.questions_setting.question16.client") }}</label>
                <input class="form-control" v-model="newClientName" />
              </div>
              <div class="col-12 col-md-6">
                <label>{{ __("forms.EvaluationChart.questions.questions_setting.question16.project") }}</label>
                <input class="form-control" v-model="newProjectName" />
              </div>
              <div class="col-12 text-right mt-5">
                <button
                type="button"
                class="btn btn--green"
                @click="addProject()">
                {{ __("forms.questions.question16.newProject") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-custom-header thead tr th {
  background: transparent;
  color: #1767A2 !important;
  font-weight: 800 !important;
}
</style>

<script>
export default {
  mounted() {
    this.populateProjects();
  },
  props: {
    is_admin: {
      type: Boolean,
      required: true,
    },

    permission: {
      type: Number,
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    owner_person_id: {
      type: Number,
      required: true,
    },
    group_id: {
      type: Number,
      required: true,
    },
    assigned_by: {
      type: Number,
      required: true,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      //default
      tableProjects: [],
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      userUrl: this.is_admin ? "" : "-user",
      newClientName: null,
      newProjectName: null,
    };
  },
  methods: {
    openNote(project_name,note) {
      Vue.swal.fire({
        title: project_name,
        text: note,
      });
    },
    updateProjectRow(row) {
      let params = {};

      axios
        .put(
          "/project-question-update-row/" +
            row.id +
            "/clientsProject" +
            this.userUrl,
          {
            row,
          },
        )
        .then((response) => {
          this.populateProjects();
        });
    },
    rmProject(row) {
      if (row.add_from_chart < 1) {
        return;
      }

      axios
        .delete("/delete-client-project-chart" + this.userUrl, {
          params: {
            client_project_id: row.id,
          },
        })
        .then((response) => {
          this.populateProjects();
        });
    },
    addProject() {
      axios
        .post("/store-client-project-chart" + this.userUrl, {
          //  "add_from_chart": 1,
          assigned_by: this.assigned_by,
          assigned_to: this.owner_person_id,
          group_id: this.group_id,
          client_name: this.newClientName,
          project_name: this.newProjectName,
        })
        .then((response) => {
          this.populateProjects();
          this.$refs.addProjectCloseModal.click();
        });
    },
    populateProjects() {
      axios
        .get("/client-projects-chart" + this.userUrl, {
          params: {
            group_id: this.group_id,
            person_id: this.owner_person_id,
          },
        })
        .then((response) => {
          this.tableProjects = response.data;
        });
    },
  },
};
</script>
